<template lang="html">
<div class="pgInner qukEdit">

    <div class="headBar">
        <span v-if="params.id">编辑快捷回复</span>
        <span v-else>新建快捷回复</span>
    </div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">标签</div>
                     <div class="bContent">
                           <el-form-item prop="tags">
                              <el-input size="medium" class="inpText" v-model="params.tags" placeholder="请输入回复标签"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">问题</div>
                     <div class="bContent">
                           <el-form-item prop="question">
                              <el-input size="medium" class="inpText" v-model="params.question" placeholder="请输入问题内容"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">回答</div>
                     <div class="bContent">
                         <!-- <textEditor ref="textEditor" :inContent="params.answer" /> -->
                         <el-form-item prop="answer">
                              <el-input type="textarea" rows="5" size="medium" v-model="params.answer" placeholder="请输入问题内容"></el-input>
                         </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName"></div>
                     <div class="bContent">
                         <table v-if="tabArr.length > 0" class="pocTab">
                              <tr>
                                  <td class="tSpan1">标题</td><td class="tSpan2">操作</td>
                              </tr>
                              <tr v-for="(item,index) in tabArr">
                                  <td class="tSpan1">{{ item.description }}</td><td class="tSpan2">
                                      <span @click="goRemove(index)" class="ibtn">删除</span>
                                  </td>
                              </tr>
                         </table>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 3">初始化中...</span>
           <span v-if="pgState == 4">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="directSave(1)" type="primary" size="small">保存并发布</el-button>
           <el-button @click="goReturn" plain size="small">取消</el-button>
      </div>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { qukCreate,qukItem } from "@/api/message/message";
import { dicSeek } from "@/api/pgMent/dictMent";
import { affList } from "@/api/affairs/affairs";
export default {
    components:{
        Editor
    },
    computed:{
      pgState:function(){
          var state = 0;
          if(this.params.id && !this.readyKey){
              state = 1;
          }

          if(this.uploadIng){
              state = 2;
          }

          return state;
      }
    },
    data(){
        return{

            pageH:'',
            selectArr:[],
            selectMap:{},
            uploadIng:false,
            selectId:'',

            readyKey:false,

            tabArr:[],
            tempStore:'',

            params:{
                id:'',
                tags:'',
                question:'',
                answer:'',
                sort:'',
                status:1
            },

            rules:{
                tags:[{
                    required:true,
                    trigger:'blur'
                }],
                question:[{
                    required:true,
                    trigger:'blur'
                }],
                answer:[{
                    required:true,
                    trigger:'blur'
                }]
            }

        }
    },

    methods:{

        goReturn:function(){
            this.$router.go(-1);
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        contentChange:function(e){    // 富文本内容
            this.params.content = e;
        },

        affSeek:function(e){
            var vues = this;
            var key = e.replace(/\s+/g,'');
            if(key){
              affList({
                  keyword:key,
                  status:1,
                  sort:2,
                  no:1,
                  size:20
              }).then(res => {
                 vues.selectArr = res.handleMattersList;
                 res.handleMattersList.forEach(item => {
                     vues.selectMap[item.id] = item;
                 })
              })
            }
        },

        affAdd:function(){
            let inTab = true;

            this.tabArr.forEach(item => {
                if(item.id == this.tempStore.id){
                    inTab = false;
                    return;
                }
            })

            if(inTab){
                this.tabArr.push(this.relateCreate(this.tempStore));
            }else{
                this.$message.error('已加入列表！');
            }

        },

        goRemove:function(inx){
            this.tabArr.splice(inx,1);
        },

        selectChange:function(e){
           this.tempStore = this.selectMap[e];
        },

        directSave:function(status){
            var vues = this;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    vues.params.status = status;
                    qukCreate({customerServiceMessage:vues.params}).then(res => {
                        vues.$router.push('quk_list');
                    })
                }

            })
        },

        imgChange:function(e){
            this.params.coverImage = e;
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            // 底部定位
            this.pageFix();

            if(querys && querys.id){
                this.params.id = querys.id;
                qukItem({id:querys.id}).then(res => {
                    vues.params = res.customerServiceMessage;
                    vues.readyKey = true;
                })
            }else{
                this.preCode = JSON.stringify(this.params);
                // this.tmSave();
            }

        },
    },
    created:function(){
        var vues = this;

        $(window).on('resize',function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

        this.prevSet();

    },

    beforeDestroy:function(){
        $(window).off('resize');
        // clearInterval(this.waitSave);
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 60px;
          padding-top: 8px;
          float: left
     }
     .bContent{
          margin-left: 70px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
               width: 420px;
          }
     }
}

.radio-block .el-radio-group{
     margin-top: 12px;
}

.pocTab{
     width: 100%;
     border-collapse: collapse;
}

.pocTab td{
    border: 1px solid #ebeef5;
    padding: 8px 20px;
}

.pocTab .tSpan2{
    width: 120px;
    text-align: center;
}

.pocTab .ibtn{
   font-size: 14px;
   cursor: pointer;
   color: #409EFF;
}

</style>

<style lang="css">

.qukEdit .el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// qukEdit.vue?3789283c